import 'tippy.js/dist/tippy.css';

import { TinyColor } from '@ctrl/tinycolor';
import { css } from '@emotion/react';
import Tippy, { type TippyProps } from '@tippyjs/react';
import { type ForwardedRef, forwardRef, memo } from 'react';

import { withLazyTippy } from '../tippy/lazy/withLazyTippy';

const LazyTippy = withLazyTippy(Tippy);

export type PopoverProps = Omit<TippyProps, 'ref'>;

export const PopoverBase = forwardRef(
  ({ ...props }: PopoverProps, ref: ForwardedRef<HTMLElement>) => (
    <LazyTippy
      arrow={false}
      trigger={props.visible !== undefined ? undefined : 'click'}
      placement="bottom-start"
      {...props}
      css={(theme) => css`
        background-color: ${theme.colors.gray[0]};
        color: ${theme.colors.gray[700]};

        border-radius: 4px;

        box-shadow:
          0px 2px 4px
            ${new TinyColor(theme.colors.gray[900]).setAlpha(0.1).toRgbString()},
          0px 0px 11px 1px
            ${new TinyColor(theme.colors.gray[900]).setAlpha(0.1).toRgbString()};

        .tippy-content {
          padding: 0;
        }
      `}
      ref={ref}
    />
  ),
);

PopoverBase.displayName = 'Popover';

export const Popover = memo(PopoverBase);
